import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  name: 'staging',
  production: false,
  appVersion: '0.0.0-stg',
  apiUrl: 'https://aur-api.inventlabs.tech/api/v1',
  graphqlUrl: 'https://aur-api.inventlabs.tech/graphql',
  storagePrefix: 'aur_admin_stg',
  enableDebugLogs: true,
};
